import useEmblaCarousel from "embla-carousel-react";
import { useDirection } from "src/i18n/direction";
import { useSSRContext } from "../../../context/SSRContext";
import { PassengerSelectionChip } from "../components";

export default function PassengerSelectionMob() {
  const direction = useDirection();
  const { cursor, passengerOptions, handleChange } = useSSRContext();
  const [emblaRef] = useEmblaCarousel({
    loop: false,
    axis: "x",
    align: "start",
    dragThreshold: 10,
    inViewThreshold: 0.1,
    active: true,
    direction,
  });

  return (
    <div ref={emblaRef} className="overflow-hidden">
      <div className="grid grid-flow-col grid-rows-1 items-stretch justify-start gap-2 p-1">
        {passengerOptions.map((passenger) => (
          <PassengerSelectionChip
            key={passenger.value}
            passenger={passenger}
            isActive={passenger.value === cursor.passengerId}
            onClick={handleChange("passengerId", passenger.value)}
          />
        ))}
      </div>
    </div>
  );
}
